import React from 'react'
import Rollbar from 'rollbar'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      rollbar: new Rollbar({
        accessToken: process.env.REACT_APP_ROLLBAR_TOKEN,
        enabled: process.env.REACT_APP_ROLLBAR_TOKEN != null,
        captureUncaught: true,
        captureUnhandledRejections: true,
        ignoredMessages: ["Kameleoon"],
        payload: {
          client: {
            javascript: {
              guess_uncaught_frames: true,
              source_map_enabled: true
            }
          },
          environment: process.env.REACT_APP_ROLLBAR_ENV
        }
      })
    }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.REACT_APP_ROLLBAR_TOKEN) {
      this.state.rollbar.error({ error, info: errorInfo })
    } else {
      console.error({error, errorInfo})
    }
  }

  render() {
    if (this.state.hasError) {
      return <h1>Sieht so aus, als wäre etwas schief gelaufen.</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary
